import React from "react"

// import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";

// import { window, document } from 'browser-monads';
// import { toast } from 'react-toastify'
import { CategoryColor } from "../utils/CategoryColor"
import styled from "styled-components"

const DivBigTitle = styled.div`
  h2 > span {
    display: inline-block;

    & > span {
      display: block;
      position: relative;
    }
  }

  .text-title {
    top: 2rem;
    z-index: 1;
    text-transform: unset;
  }

  .title-rubrica {
    color: #ee3d49;
  }

  .text-rubrica {
    text-align: left;
    color: #ffffff;
    font-family: "urw-din";
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.48px;
    line-height: 12px;
  }

  .color-bar {
    height: 22px;
    top: 1.5rem;
    left: 1.5rem;
    width: 105%;
  }

  @media only screen and (max-width: 780px) {
    h2,
    h3 {
      margin-left: 5%;
    }
    h2 {
      font-size: 52px;
      letter-spacing: -0.74px;
      line-height: 37px;
      margin-top: 12%;
    }
    h3 {
      font-size: 18px;
      letter-spacing: 0.34px;
      line-height: 22px;
      margin-top: 5%;
    }
    .text-title {
      text-transform: uppercase;
    }
    .long-title {
      font-size: 2.5rem;
    }
    .color-bar {
      height: 22px;
      top: 1.5rem;
    }
  }

  @media only screen and (max-width: 780px) and (min-width: 640px) {
    h2 {
      font-size: 80px;
      letter-spacing: -0.74px;
      line-height: 37px;
      margin-top: 15%;
    }
    h3 {
      font-size: 28px;
      letter-spacing: 0.34px;
      line-height: 22px;
      margin-top: 5%;
    }
  }
  @media only screen and (max-width: 640px) {
    h2 {
      margin-top: 18%;
    }
    .color-bar {
      height: 20px;
      top: 1.2rem;
      left: 1.2rem;
    }
  }
  .text-title.long-title.title-rubrica {
    @media only screen and (max-width: 370px) {
      font-size: 2rem;
    }

    @media only screen and (min-width: 780px) and (max-width: 1024px) {
      line-height: 60px;
      font-size: 80px;
      letter-spacing: 2px;
    }

    @media only screen and (min-width: 1024px) {
      line-height: 85px;
    }
  }
`

function PostsTitleWidget ({
    title, href
  }) {

  const [isCategory, setIsCategory] = useState(false);
  const [categoryColor, setCategoryColor] = useState('');

  useEffect(() => {
    var _title = title.replace(" ", "").toLowerCase();
    var elements = Object.keys(new CategoryColor(_title).arrayColors);
    elements.pop("default");

    console.log('elements', elements, '_title', _title);
    if (elements.includes(_title)) {
      setIsCategory(true);
      setCategoryColor(new CategoryColor(_title).color)
    }
    return () => {

    }
  }, [title, href]);

  return (
    <DivBigTitle>
      {!isCategory && !href && (
        <h2 className="mag_big_post_single_right_head_title">{title}</h2>
      )}
      {!isCategory && href && (
        <a href={href}>
          <h2 className="mag_big_post_single_right_head_title">{title}</h2>
        </a>
      )}
      {isCategory && (
        <h2 className="mag_big_post_single_right_head_title">
          <span>
            <span className="text-title  ">{title}</span>
            <span
              className="color-bar"
              style={{
                backgroundColor: categoryColor,
              }}
            ></span>
          </span>
        </h2>
      )}
    </DivBigTitle>
  )
}

export default PostsTitleWidget;